<template>
    <!--<v-container fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;height:100%;width:100%;background-color:white;">-->
    <v-container style="padding:0px 10px 5px 10px;background-color:white;">
        <v-layout column fill-height>
            <v-layout row style="padding-top:15px; overflow-x: scroll;">
                <dx-data-grid id="alertTable"
                              ref='alTable'
                              :data-source="alerts"
                              :selection="{mode:'single'}"
                              :show-column-lines="true"
                              :show-row-lines="true"
                              :show-borders="false"
                              :word-wrap-enabled="true"
                              :row-alternation-enabled="false"
                              :column-auto-width="false"
                              :column-resizing-mode="'widget'"
                              @selection-changed="setSelected">
                    <dx-paging :page-size="20"/>
                    <dx-column data-field="Vessel"/>
                    <dx-column data-field="Engine"/>
                    <dx-column data-field="Component"/>
                    <dx-column data-field="Subsystem"/>
                    <dx-column data-field="Fault"/>
                    <dx-column data-field="Status"/>
                </dx-data-grid>
            </v-layout>
            <v-layout row style="max-height:50px;padding-left:20px;">
                <v-btn flat style="color:white; background-color: rgb(51,82,128);height:30px;" @click="addNew">Add</v-btn>
                <v-btn flat style="color:white; background-color: rgb(51,82,128);height:30px;" @click="editSelected">Edit</v-btn>
                <v-btn flat style="color:white; background-color: rgb(51,82,128);height:30px;" @click="delSelected">Delete</v-btn>
                <v-spacer/>
            </v-layout>
        </v-layout>
        <v-dialog v-model="showDialog" max-width="300px">
            <v-card>
                <v-card-title v-if=" dialogMode=='add'" primary class="title" style="height:5%;">Add Alert Filter</v-card-title>
                <v-card-title v-if=" dialogMode=='edit'" primary class="title" style="height:5%;">Edit Alert Filter</v-card-title>
                <v-card-text style="height:85%;overflow:auto;">
                    <v-layout column fill-height>
                        <v-flex d-flex v-for="field in fields" v-bind:key="field">
                            <v-layout row>
                                <v-flex d-flex xs5 style="align-items:center;justify-content:flex-end;padding-right: 30px;font-size: 16px;"> {{field}}:</v-flex>
                                <v-flex d-flex xs7>
                                    <v-autocomplete v-model="dialogAlert[field]" :items="alertsFields[field]"/>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex d-flex>
                            <v-layout row>
                                <v-flex d-flex xs5 style="align-items:center;justify-content:flex-end;padding-right: 30px;font-size: 16px;">Active:</v-flex>
                                <v-flex d-flex xs7>
                                    <v-checkbox v-model="active" color="rgb(51,82,128)"/>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions style="height:10%;">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="cancelDialog">Cancel</v-btn>
                    <v-btn style="color:white; background-color: rgb(51,82,128);" @click="okDialog">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showNotification" max-width="190px">
            <p style="padding: 1rem; margin: 0; text-align: center; background-color: white;">Please select a filter first</p>
        </v-dialog>
    </v-container>
</template>

<script>
    import {DxDataGrid, DxColumn, DxPaging, DxScrolling} from 'devextreme-vue/data-grid';
    import axios from 'axios';
    import {globalStore, vessels} from "../main.js"

    export default {
        name: "AlertFilters",
        components: {
            DxDataGrid,
            DxColumn,
            DxPaging,
            DxScrolling
        },
        data() {
            return {
                alerts: [],
                selectedAlert: {},
                dialogAlert: {
                    Vessel: 'All',
                    Engine: 'All',
                    Component: 'All',
                    Subsystem: 'All',
                    Fault: 'All',
                    Status: true
                },
                alertsFields: {},
                showDialog: false,
                showNotification: false,
                dialogMode: 'add',
                fields: ['Vessel', 'Engine', 'Component', 'Subsystem', 'Fault'],
                active: true
            }
        },
        created() {
            axios.get(globalStore.config.api_location + '/getAlertSettings', {headers:{Authorization: globalStore.auth_token}}).then(response => {
                this.alertsFields['Vessel'] = ['All'].concat(response.data.data.vesselsSettings);
                this.alertsFields['Engine'] = ['All'].concat(response.data.data.enginesSettings);
                this.alertsFields['Component'] = ['All'].concat(response.data.data.componentsSettings);
                this.alertsFields['Subsystem'] = ['All'].concat(response.data.data.subsystemsSettings);
                this.alertsFields['Fault'] = ['All'].concat(response.data.data.faultsSettings);
            });

            this.alerts = Object.values(globalStore.alertFilters);
        },
        mounted() {
            window.addEventListener('orientationchange', this.onResize);
        },
        methods: {
            setSelected({selectedRowsData}) {
                this.selectedAlert = selectedRowsData[0];
            },
            addNew() {
                this.dialogAlert = {
                    Vessel: 'All',
                    Engine: 'All',
                    Component: 'All',
                    Subsystem: 'All',
                    Fault: 'All',
                    Status: true
                };

                this.active = true;

                this.dialogMode = 'add';
                this.showDialog = true;
            },
            editSelected() {
                if (Object.keys(this.selectedAlert).length > 0) {
                    this.dialogAlert = Object.assign({}, this.selectedAlert);

                    this.active = this.dialogAlert.Status;

                    this.dialogMode = 'edit';
                    this.showDialog = true;
                } else {
                    this.showNotification = true;
                }
            },
            delSelected() {
                if (Object.keys(this.selectedAlert).length > 0) {
                    var delItem = this.filterItems(this.alerts, this.selectedAlert.Id)[0];

                    axios.delete(globalStore.config.api_location + '/rule/' + this.selectedAlert.Id);

                    this.alerts.splice(this.alerts.indexOf(delItem), 1);

                    globalStore.alertFilters = this.alerts;
                    localStorage.setItem('alertFilters', JSON.stringify(this.alerts));

                    this.selectedAlert = {};
                } else {
                    this.showNotification = true;
                }
            },
            filterItems(arr, id) {
                return arr.filter(function (el) {
                    return el.Id == id;
                })
            },
            cancelDialog() {
                this.showDialog = false;
            },
            okDialog() {
                if (this.dialogMode == 'add') {
                    var newAlert = Object.assign({}, this.dialogAlert);

                    newAlert.email = globalStore.userProfile.email;

                    axios.post(globalStore.config.api_location + '/rule/new', newAlert).then(response => {
                        if (response.statusText = "Created" && Object.keys(response.data).indexOf('new_id') > -1) {
                            newAlert.Id = response.data.new_id;

                            this.alerts.push(newAlert);

                            globalStore.alertFilters = this.alerts;
                            localStorage.setItem('alertFilters', JSON.stringify(this.alerts));
                        }
                    });
                } else {
                    var editAlert = this.filterItems(this.alerts, this.dialogAlert.Id)[0],
                        newAlerts = Object.assign({}, this.dialogAlert);

                    axios.post(globalStore.config.api_location + '/rule/' + this.dialogAlert.Id + '/edit', this.dialogAlert).then(response => {
                        if (Object.keys(response.data).indexOf('alertRule') > -1) {
                            this.alerts[this.alerts.indexOf(editAlert)] = newAlerts;

                            globalStore.alertFilters = this.alerts;
                            localStorage.setItem('alertFilters', JSON.stringify(this.alerts));

                            this.selectedAlert = newAlerts;

                            this.$refs['alTable'].instance.refresh();
                        }
                    });
                }

                this.showDialog = false;
            },
            onResize() {
                setTimeout(() => {
                    this.$refs['alTable'].instance.render();
                });
            },
        },
        watch: {
            active: function () {
                this.dialogAlert['Status'] = this.active;
            }
        }
    }
</script>

<style scoped>

    #alertTable {
        font-size: 16px;
        font-family: 'Roboto', 'sans seriff';
        height: 100% !important;
    }

</style>

<style>
    #alertTable .dx-datagrid {
        width: 100% !important;
    }

    @media screen and (orientation:landscape) {
        #alertTable .dx-datagrid {
            width: 100vw !important;
        }
    }
</style>
